var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterWin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5207\u7247") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4E2D\\u6587\\u7248",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u81FB\\u901F\\u5B9D",
    transform: "translate(-1040.000000, -4030.000000)",
    fill: "#fff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.OS/Apple",
    transform: "translate(1040.000000, 4030.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    opacity: 0,
    x: 7,
    y: 7,
    width: 42,
    height: 42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,12.71725 L23.793,10.36 L23.8,27.062 L7.01575,27.16 L7,12.71725 Z M23.78775,28.952 L23.8,45.64 L7,43.26525 L7,28.84 L23.78775,28.952 Z M25.48,10.32325 L49,7 L49,26.97975 L25.48,27.16 L25.48,10.32325 Z M49,28.875 L48.99475,49 L25.51325,45.7485 L25.48,28.84 L49,28.87675 L49,28.875 Z",
    id: "\\u5F62\\u72B6"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterWin);
export default __webpack_public_path__ + "static/media/footer-win.8110a2eef7e0acc55e8630257fc1c33f.svg";
export { ForwardRef as ReactComponent };